<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="请输入档位分组名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @delete="deleteFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改 -->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改 查看
import addEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadMarketReportLevelGroupListDataApi, exportMarketReportLevelGroupListDataApi, deleteMarketReportLevelGroupApi } from '@/api/v2/marketReportLevelGroup'

export default {
  name: 'MarketReportLevelGroup',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'market_report_level_group_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['market_report_level_group_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['market_report_level_group_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['market_report_level_group_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['market_report_level_group_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['market_report_level_group_view'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          name: '',
        },
      },
      // 选中的单据ID
      id: null,
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', filterColumn: 'province_name', label: '省区', width: 130 },
      { prop: 'name', label: '档位分组', width: 150 },
      { prop: 'levelNames', label: '终端档位名称', filterColumn: 'level_names', width: 400 },
      { prop: 'sortNum', filterColumn: 'sort_num', label: '排序', width: 100 },
      { prop: 'remark', label: '备注', minWidth: 150 },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 100 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadMarketReportLevelGroupListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || []);
        _this.masterList.tableDataTotal = data.total || 0;
      }).catch()
    },
    //新增
    addFun() {
      let _this = this;
      _this.eventType = 'add';
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible;
      _this.dialogAddEditTitle = '新增市场报告档位分组设置';
    },
    // 修改
    editFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的市场报告档位分组设置', type: 'warning' })
        return
      }
      _this.id = args[0].id;
      _this.eventType = 'edit';
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible;
      _this.dialogAddEditTitle = '修改市场报告档位分组设置';
    },
    // 查看
    viewFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的市场报告档位分组设置', type: 'warning' })
        return
      }
      _this.id = args[0].id;
      _this.eventType = 'view';
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible;
      _this.dialogAddEditTitle = '查看市场报告档位分组设置';
    },
    // 作废
    deleteFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的市场报告档位分组设置', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该市场报告档位分组设置？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true })
        .then(async () => {
          deleteMarketReportLevelGroupApi({ id: args[0].id, status: 0 }).then(() => {
            _this.$message({ message: '作废成功', type: 'success' })
            _this.loadTableData()
          })
        }).catch(() => { })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportMarketReportLevelGroupListDataApi(_this.exportObj).then(response => {
        const { data } = response;
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
